import React, { useState, useEffect } from 'react'
import './styles/EventDetailsModal.css'
import why from '../assets/evening.webp'
import CloseIcon from '@mui/icons-material/Close';
import { displayEventDate, displayEventTime } from '../utils/datetime';
import { Oval } from 'react-loader-spinner';
import PinDropIcon from '@mui/icons-material/PinDrop';
import Groups3Icon from '@mui/icons-material/Groups3';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useNavigate } from "react-router";
import { useModal } from '../contexts/ModalContext';
import { useAuth } from '../contexts/AuthContext';
import { getEventCoverImage, getEventPlayers } from '../api/EventsAPI';
import { joinEvent, unjoinEvent } from '../api/UserAPI';
import { types } from '../constants/eventVars';
import { eventTypeColors } from '../constants/colors';

const coverImageCache = new Map();

export default function EventDetails({ handleClose, eventData }) {
  const { user } = useAuth();//TODO - check if user logged in else prompt to login
  const { openModal } = useModal();
  const [isloading, setisloading] = useState(false);
  const [coverImageLoading, setCoverImageLoading] = useState(false);
  const [coverImageUrl, setcoverImageUrl] = useState(null);
  const [eventPlayers, seteventPlayers] = useState([]);
  const [alreadyJoined, setalreadyJoined] = useState(false);

  const title = eventData?.title || 'undefined'
  const infoHeader = eventData?.info?.header || 'undefined'
  const infoParagraph = eventData?.info?.paragraph || 'undefined'
  // const type = eventData?.type || 'undefined'

  const eventType = types.includes(eventData?.type) ? eventData?.type : 'other'

  const locationName = eventData?.location?.name || 'undefined'
  const locationAddress = eventData?.location?.address || 'undefined'
  const hostName = eventData?.host?.name || 'undefined'
  const hostPhoto = eventData?.host?.logoUrl || 'undefined'
  const hostCreatedAt = eventData?.host?.createdAt || 'undefined'
  const createdBy = eventData?.createdBy || 'undefined'
  const createdAt = eventData?.createdAt || 'undefined'
  const maxCapacity = eventData?.maxCapacity || 'undefined'
  const registered = eventData?.registered || 'undefined'
  const eventId = eventData?.id || 'undefined'
  const eventImage = why
  const coverImageName = eventData?.coverImage || 'undefined'


  const latitude = eventData?.location?.latitude || null
  const longitude = eventData?.location?.longitude || null
  const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

  let navigate = useNavigate();

  useEffect(() => {
    initEventCoverImage()
    initEventParticipants()
  }, []);

  async function initEventCoverImage() {
    if (!coverImageName || coverImageName === 'undefined') return;
    const cacheKey = `${eventId}_${coverImageName}`;
    if (coverImageCache.has(cacheKey)) {
      setcoverImageUrl(coverImageCache.get(cacheKey));
      return;
    }
    setCoverImageLoading(true);
    const res = await getEventCoverImage(eventData.id, coverImageName);
    if (res.success) {
      coverImageCache.set(cacheKey, res.imageUrl);
      setcoverImageUrl(res.imageUrl);
    }
    setCoverImageLoading(false);
  }

  async function initEventParticipants() {
    const res = await getEventPlayers(eventData.id)
    if (!res.success) return;
    seteventPlayers(res.players)
    if (res.players.findIndex((player) => player.id === user?.uid) !== -1) {
      setalreadyJoined(true)
    }
  }

  async function buttonClicked(type) {
    if (type === 'join') { //(meetups only)
      if (user) {
        setisloading(true)
        const res = await joinEvent(user, eventData)
        if (res.success) {
          openModal("alert", {
            alertProps: { type: 2, message: "Successfully joined " + eventData.title },
          });
        } else {
          openModal("alert", {
            alertProps: { type: 0, message: "Request error, please try again." },
          });
        }
        setisloading(false)
        handleClose()
      } else {
        openModal('login')
        handleClose()
      }
    } else if (type === 'register') {// (events only)
      if (user) {
        navigate("/event/" + eventData.id + "?open=register")
        handleClose()
      } else {
        openModal('login')
        handleClose()
      }
    } else if (type === 'dropout') {// (meetups only-for now)
      setisloading(true)
      setalreadyJoined(false)
      const res = await unjoinEvent(user, eventData)
      if (res.success) {
        openModal("alert", {
          alertProps: { type: 2, message: "Successfully unjoined " + eventData.title },
        });
      } else {
        openModal("alert", {
          alertProps: { type: 0, message: "Request error, please try again." },
        });
      }
      setisloading(false)
      handleClose()
    } else {//type === 'view' (events only)
      navigate("/event/" + eventData.id)
      handleClose()
    }
  }


  const [errorIndices, setErrorIndices] = useState({}); //image render errors

  const handleError = (index) => {
    setErrorIndices((prev) => ({ ...prev, [index]: true }));
  };


  const numReserved = eventData.numReserved || 0

  return (
    <div className='backdrop' onClick={handleClose}>
      <div className='event-details-modal-body' onClick={(e) => e.stopPropagation()} >
        <div className='title-container' style={{ backgroundImage: `url(${coverImageUrl || eventImage})` }}>
          {coverImageLoading && (
            <div className='cover-image-loader'>
              <Oval visible={true} height="40" width="40" color="#ffffff" secondaryColor="#ffffff80" ariaLabel="oval-loading" />
            </div>
          )}
          <button className='close-button' onClick={handleClose}>
            <CloseIcon sx={{ color: 'white', fontSize: '30px' }} />
          </button>
          <div className='event-type' style={{
            backgroundColor: eventTypeColors[eventType].mid,
            borderColor: 'eventTypeColors[eventType].dark',
            borderWidth: '0px',
            borderStyle: 'solid',
            // color: eventTypeColors[eventType].dark,
          }}>
            {eventType}
          </div>
          <h1 className='title'>
            {title}
          </h1>
        </div>
        <div className='content-container'>
          <div className='details-container'>
            <div className='event-block'>
              <CalendarMonthOutlinedIcon sx={{ fontSize: '24px', color: 'white' }} className='event-icon' />
              <div className='event-block-content'>
                <p className='block-title'>
                  Date & Time
                </p>
                <p className='block-value'>
                  {displayEventDate(eventData)}
                </p>
                <p className='block-extra'>
                  {displayEventTime(eventData)}
                </p>
              </div>
            </div>
            <div className='event-block'>
              <a href={mapsUrl} target="_blank" rel="noopener noreferrer" style={{
                display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',
                pointerEvents: (latitude !== null && longitude !== null) ? 'auto' : 'none'
              }}>
                <PinDropIcon sx={{ fontSize: '24px', color: 'white' }} className='event-icon' />
              </a>
              <div className='event-block-content'>
                <p className='block-title'>
                  Location
                </p>
                <p className='block-value'>
                  {locationName}
                </p>
                <p className='block-extra'>
                  {locationAddress}
                </p>
              </div>
            </div>
            <div className='event-block'>
              <Groups3Icon sx={{ fontSize: '24px', color: 'white' }} className='event-icon' />
              <div className='event-block-content'>
                <p className='block-title'>
                  Participants
                </p>
                <p className='block-value'>
                  {(eventData.connectionType === "event" ? numReserved : eventPlayers.length) + " joined"}
                </p>
                <div className='participants-extra'>
                  {eventPlayers.slice(0, 5).map((user, index) => {
                    const shouldShowFallback = errorIndices[index] || !user.photoURL;
                    return (
                      <div className='avatar-container' style={{ transform: `translateX(${index * -6}px)` }} key={index}>
                        {shouldShowFallback ?
                          <div className="avatar-fallback">{user?.name?.charAt(0) || "N"}</div>
                          :
                          <img onError={() => handleError(index)} className='player-icon' src={user.photoURL} />
                        }
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className='organizer-container'>

            {hostPhoto ? <img src={hostPhoto} style={{ width: '24px', height: '24px', borderRadius: '100px' }} alt="Organizer" className='organizer-photo' />
              :
              <PersonIcon sx={{ fontSize: '24px', color: 'white' }} className='organizer-icon' />
            }
            <p>Organised by <span className='organizer-name'>{hostName}</span> </p>
            {/* <p className='organiser-name'>{eventData.createdBy}</p> */}
          </div>
          <div className='info-container'>
            <p>
              {infoHeader}
            </p>
            <p>
              {infoParagraph}
            </p>

          </div>
          <div className='button-container'>
            {eventData.connectionType === "meetup" ?
              (alreadyJoined ?
                <div className='already-joined-container'>
                  <div className='already-joined-not-button'>
                    <h4>
                      Already joined
                    </h4>
                  </div>
                  <p className='drop-out-link' onClick={() => buttonClicked('dropout')}>drop out</p>
                </div>
                :
                <button onClick={() => buttonClicked('join')} className='button' >{
                  isloading ? <Oval
                    visible={true}
                    height="30"
                    width="30"
                    color="#ffffff"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  /> : "Sign me up"}</button>)
              :
              <>
                <button onClick={() => buttonClicked('register')} className='button' >Register Now</button>
                <button onClick={() => buttonClicked('view')} className='secondary-button'>View Details</button>
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
